import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

export const API = process.env.REACT_APP_BACKEND_URL;
export const qa = {
  get: (p, params) => axios.get(`${API}/api/quality${p}`, { withCredentials: true, params }).then(r => r.data),
  post: (p, body) => axios.post(`${API}/api/quality${p}`, body || {}, { withCredentials: true }).then(r => r.data),
  put: (p, body) => axios.put(`${API}/api/quality${p}`, body || {}, { withCredentials: true }).then(r => r.data),
  upload: (p, file) => { const fd = new FormData(); fd.append('file', file); return axios.post(`${API}/api/quality${p}`, fd, { withCredentials: true }).then(r => r.data); },
};
export const errMsg = (e, fb = 'Something went wrong') => {
  const d = e?.response?.data?.detail;
  return typeof d === 'string' ? d : (d?.message || fb);
};
export const fail = (e, fb) => toast.error(errMsg(e, fb));

export const STATUS = {
  setup_started: ['Setup Started', 'bg-amber-100 text-amber-800'],
  setup_completed: ['Setup Completed', 'bg-amber-100 text-amber-800'],
  inspection_pending: ['Inspection Pending', 'bg-orange-100 text-orange-800'],
  qa_approval_pending: ['QA Approval Pending', 'bg-blue-100 text-blue-800'],
  approved: ['Approved', 'bg-emerald-100 text-emerald-800'],
  rejected: ['Rejected', 'bg-red-100 text-red-800'],
  reinspection_required: ['Reinspection Required', 'bg-red-100 text-red-800'],
  production_released: ['Production Released', 'bg-emerald-600 text-white'],
  quality_hold: ['QUALITY HOLD', 'bg-red-600 text-white animate-pulse'],
  completed: ['Completed', 'bg-slate-200 text-slate-700'],
  closed: ['Closed', 'bg-slate-200 text-slate-700'],
  draft: ['Draft', 'bg-slate-200 text-slate-700'],
  pending_approval: ['Pending Approval', 'bg-blue-100 text-blue-800'],
  superseded: ['Superseded', 'bg-slate-100 text-slate-500'],
  obsolete: ['Obsolete', 'bg-slate-100 text-slate-400 line-through'],
};
export const DUE = {
  upcoming: ['Upcoming', 'text-slate-500'], due_soon: ['Due soon', 'text-amber-600'], due_now: ['Due now', 'text-orange-600 font-bold'],
  overdue: ['OVERDUE', 'text-red-600 font-bold'], escalated: ['OVERDUE — escalated', 'text-red-700 font-black'],
};

export const StatusBadge = ({ status, testid }) => {
  const [label, cls] = STATUS[status] || [status, 'bg-slate-100'];
  return <span data-testid={testid} className={`inline-block text-[11px] font-bold uppercase px-2 py-1 rounded ${cls}`}>{label}</span>;
};

export const fmtTime = (iso) => iso ? new Date(iso.endsWith?.('Z') || iso.includes?.('+') ? iso : iso + 'Z').toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '-';

export async function openFile(fileId) {
  const w = window.open('', '_blank');
  try {
    const r = await axios.get(`${API}/api/quality/files/${fileId}`, { withCredentials: true, responseType: 'blob' });
    const url = URL.createObjectURL(r.data);
    if (w) w.location.href = url; else window.open(url, '_blank');
  } catch (e) { if (w) w.close(); fail(e, 'Could not open drawing'); }
}

export async function downloadReport(inspId) {
  try {
    const r = await axios.get(`${API}/api/quality/inspections/${inspId}/report`, { withCredentials: true, responseType: 'blob' });
    const cd = r.headers['content-disposition'] || '';
    const name = decodeURIComponent((cd.match(/filename="(.+)"/) || [])[1] || 'Inspection_Report.xlsx');
    const a = document.createElement('a'); a.href = URL.createObjectURL(r.data); a.download = name; a.click();
  } catch (e) {
    let msg = 'Report download failed';
    try { msg = JSON.parse(await e.response.data.text()).detail || msg; } catch { /* keep default */ }
    toast.error(msg);
  }
}

export function useQaMe() {
  const [me, setMe] = useState({ roles: [], can_inspect: false, can_approve: false, is_admin: false, loaded: false });
  useEffect(() => { qa.get('/me').then(d => setMe({ ...d, loaded: true })).catch(() => setMe(m => ({ ...m, loaded: true }))); }, []);
  return me;
}

export const PageTitle = ({ title, sub, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-3 mb-6">
    <div>
      <h1 className="text-3xl font-black text-slate-900" style={{ fontFamily: 'Chivo' }}>{title}</h1>
      {sub && <p className="text-sm text-slate-500 mt-1">{sub}</p>}
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);
